import * as yup from 'yup';
import { INVALIDATION_TIP, REGEX } from '../../../const/validation';

export const CartRegSchema = yup.object().shape({
  customer_name: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(REGEX.VALID_CUSTOM_NAME, INVALIDATION_TIP.INCORRECT_NAME_NO_NUMBER)
    .min(2, INVALIDATION_TIP.MIN_LENGTH_NAME),
  customer_company_name: yup.string().nullable().optional(),
  phone: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(/^\d{10}/, INVALIDATION_TIP.INCORRECT_PHONE),
  customer_email: yup
    .string()
    .required(INVALIDATION_TIP.FIELD_REQUIRED)
    .matches(REGEX.VALID_EMAIL, INVALIDATION_TIP.INCORRECT_EMAIL),
  customer_company_requisites: yup.mixed(),
  comment: yup.string(),
});
